<template>
  <div>
    <div v-if="!add">
      <h2>Lägg till System Nexa</h2>
      <p>Välj vilken typ av enhet du vill lägga till här nedanför, beroende på vad du väljer kommer du antingen få sätta din mottagare i upplärningsläge eller aktivera sin sändare. Exempelvis öppna en magnetkontakt om du vill lägga till en sådan.</p>

        <p><input type="text" v-model="modelSearch" @keyup="searchProductDatabase" placeholder="Skriv modellbeteckningen (MYCR-2300) eller artikelnumret på din enhet"></p>      
      
        <div v-if="gotSearchItems" style="margin-bottom:25px;">
          <table>
            <thead>
              <tr>
                <th colspan="3">Modell</th>
              </tr>
            </thead>
            
            <tbody>
              <tr v-for="item in modelSearchItems" @click="addFromSearch(item)">
                <td>{{ item.name }}<div v-if="item.notes.length" style="font-size:11px;color:#959595;">{{ item.notes }}</div></td>
                <td align="right" v-if="item.pdf.length"><a href="#">Visa manual</a></td>
                <td width="110" align="right" v-if="item.capabilities.length">Lägg till &rarr;</td>
              </tr>
            </tbody>
          </table>        
        </div>
        
          <div class="bootstrap-wrapper" :style="{ opacity: (gotSearchItems ? .4 : 1) }">
          	<div class="container">
          		<div class="row">
          			<div class="col-md-4" v-for="item in items" style="padding-right:0px;padding-left:8px;" @click="go(item)">
            			<div style="position:absolute;width:100%;text-align:center;margin-top:0px;top:10px;font-weight:bold;">{{ item.name }}</div>
            			<img :src="item.image" style="width:100%;object-fit:cover;border:1px solid #b5b5b5;">
          			</div>
          		</div>
          	</div>
          </div>
        </div>
        <div v-else>
          <h2>{{ type.name }}</h2>
          
          <div v-if="type.type == 'NexaSwitch' || type.type === 'EJLR1000_Node' || type.type === 'NexaDimmer'">
            <h3>Skickar ut upplärningssignaler...</h3>
    
            <p>Vi kommer nu att lägga till en mottagare, detta kräver att du går fram till din mottagare och sätter den i upplärningsläge. Något du oftast gör genom att antingen trycka på en liten
              knapp som finns på den alternativt genom att ta ur den ur väggen och stoppa i den igen. Gör detta nu.
            </p>
            
            <div style="padding-left:45%;padding-top:1em;">
              <half-circle-spinner :animation-duration="1000" :size="90" color="#033873" />
            </div>
    
            <p>Tryck på nedanstående knapp när du märker att din mottagare är upplärd, oftast genom att lasten blinkar eller att mottagaren klickar till.</p>
            <button @click="save">Fortsätt till nästa steg</button>
          </div>
          <div v-else-if="type.type == 'NexaTransmitter'">
            <h3>Lyssnar efter koder...</h3>
    
            <p>Din Nexa Bridge lyssnar nu efter sändare, aktivera din sändare så kommer du att tas vidare automatiskt där du kan spara din enhet. Aktivera innebär att du antingen öppnar magnetkontakten, ställer dig framför din rörelsevakt eller trycker <strong>PÅ</strong> på din fjärrkontroll.</p>          
            
            <loading-view v-if="!checkmark"></loading-view>
            <div style="text-align:center;margin-top:1em;">
              <div v-if="checkmark"><img src="../assets/check.gif" width="350"></div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import { HalfCircleSpinner } from 'epic-spinners'
  import { eventbus } from '../eventbus'
  import loadingView from './views/loadingView'

export default {
  name: 'HelloWorld',
  components: {
    HalfCircleSpinner,
    loadingView
  },
  data () {
    return {
      items: [],
      add: false,
      type: {},
      learningCodeTimer: null,
      sendLearningCodes: true,
      listenForTransmitters: true,
      data: {},
      checkmark: false,
      modelSearch: '',
      modelSearchTimer: null,
      modelSearchItems: [],
      showCategoriesAfterDelay: false
    }
  },
  computed: {
    gotSearchItems () {
      return Object.keys(this.modelSearchItems).length
    }
  },
  methods: {
    searchProductDatabase () {
      if (this.modelSearch.length < 2) {
        this.modelSearchItems = []
        return
      }
      
      if (this.modelSearchTimer) 
        clearTimeout(this.modelSearchTimer)
      this.modelSearchTimer = setTimeout(() => {
        fetch('https://app.nexabridge.se/products?model=' + this.modelSearch)
        .then(res => res.json())
        .then(json => {
          this.modelSearchItems = json.map(i => {
            return i
          })
        })
               
      }, 200)
    },
    
    go (item) {
      this.add = true
      this.type = item
      
      if (this.type.type === 'NexaSwitch' || this.type.type === 'EJLR1000_Node' || this.type.type === 'NexaDimmer') {
        this.sendLearningCodes = true
        this.sendLearningCode()
      } else {
        
        // Avbryt tidigare tilläggning ifall vi har en sådan, på detta sätt ser vi till
        // att det alltid fungerar som det skall.
        HTTP.post('nodeops/nexaOperations/learnTransmitter?action=abort')
        .then(res => res.data)
        .then(json => {
          this.beginListenForTransmitters()
        })
      }
    },

    sendLearningCode () {
      // Skicka till Bridgen
      HTTP.post('nodeops/nexaOperations/sendLearningCode')
      .then(res => res.data)
      .then(json => {
        this.data = json
        
        // Väntar 1 sekund från det att vi fick svar till att
        // vi skickar ut igen.
        setTimeout(() => {
          if (this.sendLearningCodes) {
            this.sendLearningCode()
          }
        }, 800)
      })
    },

    beginListenForTransmitters () {
      HTTP.post('nodeops/nexaOperations/learnTransmitter?action=start')
      .then(res => res.data)
      .then(json => {
        
        // När vi har börjat lyssna på sändare kommer vi här också att sätta upp
        // en lyssnare på socketen som lyssnar efter nya koder och som i sin tur
        // skickar vidare användaren till Spara-vyn.        
        eventbus.$once('nexaCode', (json) => {
          const addr = json.addr
          const subaddr = json.subaddr

          this.$root.tempSaveStore = {
            capabilities: this.type.capabilities,
            type: this.type.type,
            nexaInfo: {
              addr: addr,
              subaddr: subaddr
            }
          }
          
          this.checkmark = true
          
          // Vänta att skicka vidare användaren till vi har animerat checkmarken 
          // och så att användaren har sett den.
          setTimeout(() => {
            this.$router.push({
              name: 'save_node'
            })
          }, 1800)
        })
      })
    },

    stopListenForTransmitters () {
      HTTP.post('nodeops/nexaOperations/learnTransmitter?action=abort')
    },
    
    save () {
      this.$root.tempSaveStore = {
        capabilities: this.type.capabilities,
        type: this.type.type,
        id: this.data.id
      }

      this.$router.push({
        name: 'save_node'
      })
    },
    
    addFromSearch (item) {
      console.log(item)
      this.go(item)
    }
    
  },
  created () {
    //this.items = require('../devices.json')
    setTimeout(() => this.showCategoriesAfterDelay = true, 500)
    
    
    fetch('https://app.nexabridge.se/devices/nexa')
    .then(res => res.json())
    .then(json => this.items = json)
    

    eventbus.$off('nexaCode')
  },

  // När vyn försvinner
  destroyed () {
    this.sendLearningCodes = false
    this.listenForTransmitters = false
    this.stopListenForTransmitters()
    eventbus.$off('nexaCode')
  }
}
</script>


// WEBPACK FOOTER //
// src/components/add_systemnexa.vue